import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

import { usePlace } from 'commons/usePlace'

import { CANCEL } from 'app/constants/button'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import { isNil } from 'ramda'

const Delete = (props) => {
  const {
    closeMenu = () => {},
    onAction,
    rootAdmin = {},
    selected = [],
    selectedCount = null,
  } = props

  const place = usePlace()
  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)
  const [isDisable, setIsDisable] = useState(false)
  const [isAnnounce, setIsAnnounce] = useState(false)

  const handleOpen = () => {
    if (selected.includes(place.creatorId) && !isNil(rootAdmin)) {
      setIsAnnounce(true)
    } else setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  const handleCloseAnnounce = () => {
    setIsAnnounce(false)
    closeMenu()
  }

  const handleSubmit = async () => {
    const withoutRoot = selected.filter((id) => id !== place.creatorId)
    await onAction(withoutRoot)
    handleCloseAnnounce()
  }

  useEffect(() => {
    const checkDisable =
      selected.length === 1 && selected.includes(place.creatorId)
    setIsDisable(checkDisable)
  }, [place.creatorId, selected])

  return (
    <div>
      {!isNil(rootAdmin) && selectedCount > 0 && (
        <Typography
          className={clsx(
            'text-14 font-400',
            isDisable ? 'text-grey-200' : 'text-red-500 cursor-pointer',
          )}
          onClick={() => !isDisable && handleOpen()}
        >
          {formatMessage(
            {
              id: 'teamMembers.table.action.deleteAll.label',
            },
            { count: selectedCount },
          )}
        </Typography>
      )}
      {isNil(selectedCount) && (
        <MenuItem onClick={() => handleOpen()} className="space-x-5">
          <DeleteOutlineIcon fontSize="small" className="text-red-500" />
          <Typography className="text-14 font-400 text-red-500">
            {formatMessage({
              id: 'action.delete',
            })}
          </Typography>
        </MenuItem>
      )}

      <SubmitDialog
        id="dialog-delete-team-member"
        open={isOpen}
        type={CANCEL}
        title={formatMessage({
          id: 'teamMembers.delete.title',
        })}
        description={formatMessage(
          {
            id: 'teamMembers.delete.description',
          },
          { selectedCount: selectedCount },
        )}
        submitText={formatMessage({
          id: 'action.delete',
        })}
        onSubmit={async () => {
          await onAction(selected)
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />

      <SubmitDialog
        id="dialog-announce-delete-team-member"
        open={isAnnounce}
        type={CANCEL}
        title={formatMessage({
          id: 'teamMembers.delete.title',
        })}
        submitText={formatMessage({
          id: 'action.delete',
        })}
        onSubmit={() => handleSubmit()}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleCloseAnnounce()}
      >
        <div className="space-y-5 text-primary">
          <Typography>
            {formatMessage({
              id: 'teamMembers.dialog.confirm.delete.hasRootAdmin.body1',
            })}
          </Typography>
          <Typography className="font-bold italic">
            {`${rootAdmin?.firstName ?? ''} ${rootAdmin?.lastName ?? ''}`}
          </Typography>
          <Typography>
            {formatMessage({
              id: 'teamMembers.dialog.confirm.delete.hasRootAdmin.body2',
            })}
          </Typography>
        </div>
      </SubmitDialog>
    </div>
  )
}

Delete.propTypes = {
  onAction: PropTypes.func,
  selected: PropTypes.array,
  closeMenu: PropTypes.func,
  className: PropTypes.string,
  rootAdmin: PropTypes.object,
  selectedCount: PropTypes.number,
}

export default Delete
